"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserOrders = exports.getUser = void 0;

var _http = require("js-utils/http");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getUser = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (0, _http.fetchEB)('/api/v3/users/me/').then(function (response) {
              return response.json().then(function (responseData) {
                return Promise.resolve(responseData);
              });
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getUser() {
    return _ref.apply(this, arguments);
  };
}();

exports.getUser = getUser;

var getUserOrders = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", (0, _http.fetchEB)('/api/v3/users/me/orders/?time_filter=current_future&expand=event,event.has_digital_content').then(function (response) {
              return response.json().then(function (responseData) {
                return Promise.resolve(responseData);
              });
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getUserOrders() {
    return _ref2.apply(this, arguments);
  };
}();

exports.getUserOrders = getUserOrders;
//# sourceMappingURL=index.js.map